var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"unit-card-indicator"},[_c('AppIcon',{staticClass:"unit-card-indicator__icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}),_c('span',{staticClass:"unit-card-indicator__text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }